import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52b6c6b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oktell-create-ltl-order" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_step_company = _resolveComponent("step-company")!
  const _component_step_senders = _resolveComponent("step-senders")!
  const _component_new_additional_services = _resolveComponent("new-additional-services")!
  const _component_step_date = _resolveComponent("step-date")!
  const _component_step_receivers = _resolveComponent("step-receivers")!
  const _component_step_cargo = _resolveComponent("step-cargo")!
  const _component_step_create = _resolveComponent("step-create")!
  const _component_completed_cargos = _resolveComponent("completed-cargos")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_step_company, {
      "step-number": 1,
      disabled: _ctx.disabled,
      "company-id": _ctx.state.company_id,
      onSubmit: _ctx.onCompanySubmit,
      onReset: _ctx.onCompanyReset
    }, null, 8, ["disabled", "company-id", "onSubmit", "onReset"]),
    _createVNode(_component_step_senders, {
      "step-number": 2,
      opened: _ctx.isCompanySelected,
      "company-id": _ctx.state.company_id,
      disabled: _ctx.disabled,
      onSubmit: _ctx.onSenderSubmit,
      onReset: _ctx.onSenderReset
    }, null, 8, ["opened", "company-id", "disabled", "onSubmit", "onReset"]),
    _createVNode(_component_new_additional_services, {
      "is-sender": "",
      opened: _ctx.isCompanySelected,
      "additional-services": _ctx.state.additional_services,
      disabled: _ctx.disabled,
      "initial-value": _ctx.state.sender_additional_services,
      "is-setted": _ctx.state.is_sender_additional_services_setted,
      "is-update": _ctx.state.is_sender_additional_services_update,
      onSubmit: _ctx.onSubmitSenderAdditionalServices,
      onUpdate: _ctx.onStartUpdateSenderAdditionalServices
    }, null, 8, ["opened", "additional-services", "disabled", "initial-value", "is-setted", "is-update", "onSubmit", "onUpdate"]),
    _createVNode(_component_step_date, {
      "step-number": 3,
      opened: _ctx.isSenderSelected,
      disabled: _ctx.disabled,
      onSubmit: _ctx.onDateSubmit,
      onReset: _ctx.onDateReset
    }, null, 8, ["opened", "disabled", "onSubmit", "onReset"]),
    _createVNode(_component_step_receivers, {
      "with-excel": false,
      "step-number": 4,
      opened: _ctx.isSenderSelected,
      "sender-id": _ctx.state.sender_id,
      "sender-city-id": _ctx.state.sender_city_id,
      "company-id": _ctx.state.company_id,
      receiver: _ctx.state.receiver,
      disabled: _ctx.disabled,
      "selected-receivers-ids": _ctx.selectedReceiversIds,
      hint: _ctx.LTLHintText,
      onSubmit: _ctx.onReceiverSubmit,
      onReset: _ctx.onReceiverReset
    }, null, 8, ["opened", "sender-id", "sender-city-id", "company-id", "receiver", "disabled", "selected-receivers-ids", "hint", "onSubmit", "onReset"]),
    _createVNode(_component_step_cargo, {
      "step-number": 5,
      "additional-services": _ctx.state.additional_services,
      opened: _ctx.isReceiverSelected,
      "is-update": _ctx.state.is_updating_cargo,
      "updating-cargo-index": _ctx.state.updating_cargo_index,
      "updating-cargo": _ctx.state.updating_cargo,
      disabled: _ctx.disabled,
      "company-id": _ctx.state.company_id,
      "company-verify": _ctx.state.company_verify,
      "sender-city-id": _ctx.state.sender_city_id,
      receiver: _ctx.state.receiver,
      onSubmit: _ctx.onCargoSubmit,
      onCancelUpdate: _ctx.cancelUpdateCargo,
      "is-no-cash-input": ""
    }, null, 8, ["additional-services", "opened", "is-update", "updating-cargo-index", "updating-cargo", "disabled", "company-id", "company-verify", "sender-city-id", "receiver", "onSubmit", "onCancelUpdate"]),
    (_ctx.state.completed_cargos.length >= 5 && !_ctx.state.is_order_created)
      ? (_openBlock(), _createBlock(_component_step_create, {
          key: 0,
          loading: _ctx.disabled,
          onSubmit: _ctx.onSubmitOrder
        }, null, 8, ["loading", "onSubmit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_completed_cargos, {
      cargos: _ctx.state.completed_cargos,
      disabled: _ctx.disabled,
      "additional-services": _ctx.state.additional_services,
      "is-bosch": _ctx.isBosch,
      onDeleteCargo: _ctx.onDeleteCargo,
      onUpdateCargo: _ctx.onStartUpdateCargo,
      onUpdateAdditionalServices: _ctx.onUpdateCompletedCargoAdditionalServices
    }, null, 8, ["cargos", "disabled", "additional-services", "is-bosch", "onDeleteCargo", "onUpdateCargo", "onUpdateAdditionalServices"]),
    (_ctx.state.completed_cargos.length > 0 && _ctx.isDateSelected)
      ? (_openBlock(), _createBlock(_component_step_create, {
          key: 1,
          created: _ctx.orderCreated,
          loading: _ctx.disabled,
          onSubmit: _ctx.onSubmitOrder,
          onNewOrder: _ctx.resetOrder
        }, null, 8, ["created", "loading", "onSubmit", "onNewOrder"]))
      : _createCommentVNode("", true)
  ]))
}